import { createSlice } from "@reduxjs/toolkit";
import {
    Tabs,
    StatusTitle,
    ContentTypeTitle,
    PriorityTitle

} from "../types/Constants";


const contentRequestSlice = createSlice({
    name: 'contentRequest',
    initialState: {
        activeTab: Tabs.SentRequest,
        pageNumber: 1,
        pageSize: 20,
        sentRequestsTotalPages: null,
        totalCount:null,
        receivedRequestTotalPages: null,
        contentRequest: null,
        sentContentRequestsData: [],
        ownerTaskByRoleData: [],
        feedBackData: {},
        receivedContentRequestsData: [],
        dateFilter: {
            type: '',
            from: null,
            to: null
        },
        statusFilter: [],
        contentTypeFilter: [],
        priorityFilter: [],
        searchBar: {
            searchText: '',
            isSearchByRequestID: false,
            isSearchByRequestTitle: false
        },
        suggestions: [],
        deleteStatus: false,
        addFeedback: {},
        resolveFeedback: {},
        replyFeedback: {},
        refreshFeedback: false
        
    },
    reducers: {
        resetFilters: (state, action) => {
            state.dateFilter =  {
                type: '',
                from: null,
                to: null
            };
            state.statusFilter = [];
            state.contentTypeFilter = [];
            state.priorityFilter = [];
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
            state.dateFilter = {
                type: '',
                from: null,
                to: null
            };
            state.statusFilter = [];
            state.contentTypeFilter = [];
            state.priorityFilter = [];
        },
        setSentContentRequestsData: (state, action) => {
            return {
                ...state,
                sentContentRequestsData: action.payload
            }
        },
        setContentRequest: (state, action) => {
            state.contentRequest = action.payload.contentRequestDetails;
        },
        setOwnerTaskByRoleData: (state, action) => {
            return {
                ...state,
                ownerTaskByRoleData: action.payload
            }
        },
        setFeedback: (state, action) => {
            return {
                ...state,
                feedBackData: action.payload,
                refreshFeedback: false
            }
        },
        setReceivedContentRequestsData: (state, action) => {
            return {
                ...state,
                receivedContentRequestsData: action.payload
            }
        },
        addNewFeedback: (state, action) => {
            return {
                ...state,
                addFeedback: action.payload,
                refreshFeedback: true
            }
        },
        resolveFeedback: (state, action) => {
            return {
                ...state,
                resolveFeedback: action.payload,
                refreshFeedback: true

            }
        },
        replyFeedback: (state, action) => {
            return {
                ...state,
                replyFeedback: action.payload,
                refreshFeedback: true

            }
        },
        setDateFilter: (state, action) => {
            const { type, from, to } = action.payload;
            state.dateFilter = {
                type: type,
                from: from,
                to: to
            }
            state.pageNumber = 1
        },
        setStatusFilter: (state, action) => {
            switch (action.payload) {
                case StatusTitle.draft:
                case StatusTitle.published:
                    if (state.statusFilter.includes(action.payload)) {
                        // const index = state.statusFilter.indexOf(action.payload);
                        // console.log(index);
                        // state.statusFilter.splice(index, 1);
                        const updatedStatusFilter = state.statusFilter.filter((status) => status !== action.payload)
                        state.statusFilter = updatedStatusFilter;
                    } else {
                        state.statusFilter.push(action.payload);
                    }
                    // state.statusFilter = [];
                    // state.statusFilter.push(action.payload);
                    break;
                default:
            }
            state.pageNumber = 1
        },
        setContentTypeFilter: (state, action) => {
            switch (action.payload) {
                case ContentTypeTitle.test:
                case ContentTypeTitle.questions:
                case ContentTypeTitle.studyMaterial:
                    if (state.contentTypeFilter.includes(action.payload)) {
                        const index = state.contentTypeFilter.indexOf(action.payload);
                        state.contentTypeFilter.splice(index, 1);
                    } else {
                        state.contentTypeFilter.push(action.payload);
                    }
                    // state.contentTypeFilter = [];
                    // state.contentTypeFilter.push(action.payload);
                    break;
                default:
            }
            state.pageNumber = 1
        },
        setPriorityFilter: (state, action) => {
            switch (action.payload) {
                case PriorityTitle.importantAndUrgent:
                case PriorityTitle.notImportantButUrgent:
                case PriorityTitle.importantButNotUrgent:
                case PriorityTitle.notImportantAndNotUrgent:
                    if (state.priorityFilter.includes(action.payload)) {
                        const index = state.priorityFilter.indexOf(action.payload);
                        state.priorityFilter.splice(index, 1);
                    } else {
                        state.priorityFilter.push(action.payload);
                    }
                    // state.priorityFilter = [];
                    // state.priorityFilter.push(action.payload);
                    break;
                default:
            }
            state.pageNumber = 1
        },
        setSearchBar: (state, action) => {
             let updatedSearchBar = state.searchBar;
            updatedSearchBar.searchText = action.payload.searchText;
            if (updatedSearchBar.searchText.includes('-')) {
                updatedSearchBar.isSearchByRequestID = true;
                updatedSearchBar.isSearchByRequestTitle = false;
            } else {
                updatedSearchBar.isSearchByRequestTitle = true;
                updatedSearchBar.isSearchByRequestID = false;
            }
            state.searchBar = updatedSearchBar
        },
        setSuggestions: (state, action) => {
            state.suggestions = action.payload
        },
        setDeleteStatus: (state, action) => {
            return {
                ...state,
                deleteStatus: !state.deleteStatus
            }
        },
        setSentRequestsTotalPages:(state, action) => {
            if(action.payload){
                state.sentRequestsTotalPages =  action.payload;
            }
            
        },
        setSentRequestsTotalCount:(state, action) => {
            if(action.payload){
                state.totalCount =  action.payload;
            } 
        },

        setReceivedRequestsTotalPages: (state, action) => {
            state.receivedRequestTotalPages = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.pageNumber = action.payload
        },

    }
});

const { actions, reducer } = contentRequestSlice;

export default reducer;
export const contentRequestActions = actions;